import { Button, Card, Col, Row } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { VIEWALL_IMG } from "../../../constants/Constant";

const BIWidgetOverview = ({ catalogData, name, compType }) => {


  const { catalogCount, catalogdata } = catalogData;
  return (
    <>
      <>
        <div className="datasets__type__header pt-3">

          <div className="sub__header">
            {" "}
            <span className="do__bu__tag">
              {" "}
              {name} ({catalogCount?.length})
            </span>
          </div>

          <h2 className="view__spacing">
            <NavLink
              to="/databook/viewallreports"
              state={{ from: compType }}
            >
              <Button className="view__all__data">
                <img src={VIEWALL_IMG} alt="View All icon" />
                <span>View All</span>
              </Button>
            </NavLink>
          </h2>
        </div>
        <Row className="gy-3  pt-3 biz-dom-wrap py-4">
          {catalogdata?.map((d, index) => {
            return (
              <Col xs={12} sm={6} md={6} lg={4} xl={2} xxl={2} key={index}>
                {" "}
                <Link
                  to={`/databook/bicatalog/dashboard/${d.fqn}`}
                  className="widg__f"
                >
                  <Card className="shadow-none border rounded-1 text-center h-100">
                    <Card.Body className="bg-transparent rounded-1">
                      <div className="main__b">
                        {/* <span role="img" className="dataset_img_b">
                          <img src={PERFORMANCE_IMG} alt="Datasets" />
                        </span>
                        <div className="sub__b">
                          <span className="data__stan__name">{d.name}</span>
                        </div> */}
                        <div>
                          <div className="card_label_full"><span className="bd__name text-wrap">{d.name}</span></div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
            );
          })}
        </Row>
      </>
    </>
  );
};

export default BIWidgetOverview;
